const initialState = {
  isLoadingScenarioDetails: false,
  scenarioDetails: [],

  isLoadingCreateScenarioDetail: false,
  isLoadingUpdateScenarioDetail: false,
  isLoadingRemoveScenarioDetail: false,
};

export default initialState;
